module.exports = __webpack_public_path__ + "img/ge.1b6df42c.jpg";